import { defineStore } from 'pinia';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { ISeoHeadComponent } from '~/types/seoHead';

export const useStoreGamePage = defineStore('gamePage', {
  state: () => ({
    demoModeOffTitle: '',
    demoModeOnTitle: '',
    favouritesTitle: '',
    hitRateTitle: '',
    latestWinnersTitle: '',
    linesTitle: '',
    payoutTitle: '',
    racesTitle: '',
    specsTitle: '',
    valueTitle: '',
    volatilityRatingTitle: '',
    waysTitle: '',
    head: {} as ISeoHeadComponent,
    countryRestrictedText: '',
    countryRestrictedTextCanada: '',
    currencyRestrictedTitle: '',
    currencyRestrictedText: '',
    oneWindowModeTitle: '',
    twoWindowModeTitle: '',
    fourWindowModeTitle: '',
    fullScreenTitle: '',
    closeGameTitle: '',
    popularGamesTitle: '',
    lastPlayedGamesTitle: '',
    recommendedGamesText: '',
    currencyUnsapportedTitle: '',
    currencyUnsapportedText: '',
    currencyExchangeTitle: '',
    currencyExchangeText: '',
    bonusesTitle: '',
    sorryTitle: '',
    multislotUnavailableText: '',
    lobbyTitle: '',
    toggleSidebarTitle: '',
    searchReplaceSingleModeText: '',
    searchReplaceMultiModeText: '',
    noBonusesText: '',
    theaterModeTitle: '',
    maxBetRestrictText: '',
    noRacesText: '',
    favoriteTooltipText: '',
    availableFreespinText: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadGamePage() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['head', 'head.alternates']);

        this.requestPromise = strapi()
          .get('game-page', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
